// extracted by mini-css-extract-plugin
module.exports = {"News":"reviewsVidget_News__IlSpm"};